/* app/ui/filter/filter */

import $ from 'jquery';
import { Core } from 'Util/core';

var selectors = {
	form: '.js-filter__form',
	resetButton: '.js-filter__reset',
	scrollTarget: '.js-filtered-listing',
	activeFilter: '.js-active-filter',
	itemCount: '.js-experience-list-count',
	paginationLink: '.js-pagination-link'
};

var Filter = {
    init: function () {
        Filter._initEvents();
        Filter._scrollToResults();
    },

    _initEvents: function () {
        $(document).on('submit', selectors.form, Filter._handleSubmit);
        $(document).on('click', selectors.resetButton, Filter._handleReset);
        $(document).on('click', selectors.activeFilter, Filter._handleActiveFilterClick);
        $(document).on('click', selectors.paginationLink, Filter._handlePaginationClick);
        $(document).on('change', selectors.paginationLink, Filter._handlePaginationChange);
    },

    _handleSubmit: function (e) {
        // Store scroll intent in sessionStorage before form submits
        sessionStorage.setItem('filterScrollPending', 'true');
    },

    _handleReset: function (e) {
        // Store scroll intent in sessionStorage before navigating
        sessionStorage.setItem('filterScrollPending', 'true');
        // Navigate to current page without query parameters
        window.location.href = window.location.pathname;
    },

    _handleActiveFilterClick: function (e) {
        var $activeFilter = $(e.currentTarget);
        var filterSegment = $activeFilter.data('filter-segment');
        var filterValue = $activeFilter.data('filter-value');

        // Find and uncheck the corresponding checkbox
        var checkboxSelector = 'input[name="filter-' + filterSegment + '"][value="' + filterValue + '"]';
        var $checkbox = $(checkboxSelector);

        if ($checkbox.length) {
            $checkbox.prop('checked', false);

            // Store scroll intent and submit the form
            sessionStorage.setItem('filterScrollPending', 'true');
            $(selectors.form).submit();
        }
    },

    _handlePaginationClick: function (e) {
        // Store scroll intent when pagination link is clicked
        sessionStorage.setItem('filterScrollPending', 'true');
    },

    _handlePaginationChange: function (e) {
        // Store scroll intent when pagination dropdown changes (mobile)
        sessionStorage.setItem('filterScrollPending', 'true');
    },

    _scrollToResults: function () {
        // Check if we should scroll after page load
        var shouldScroll = sessionStorage.getItem('filterScrollPending');

        if (shouldScroll === 'true') {
            sessionStorage.removeItem('filterScrollPending');

            var $target = $(selectors.scrollTarget);
            if ($target.length) {
                // Small delay to ensure page is fully loaded
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $target.offset().top - 40
                    }, 300);
                }, 100);
            }
        }

        // Always update the count display
        Filter._updateCount();
    },

    _updateCount: function () {
        var $countElement = $(selectors.itemCount);
        if ($countElement.length) {
            // Count is already rendered by the server, just ensure it's visible
            $countElement.css('opacity', '0').animate({ opacity: 1 }, 300);
        }
    }
};

export { Filter };
